import { c as _c } from "react/compiler-runtime";
import type { CustomerFunnelStage } from '@sizzlenz/shared';
import Link from 'next/link';
import { ArrowRight, CircleDot } from 'lucide-react';
import { buildInspirationFeedHref, TEXT } from './shared';
const journeyOutcomes: {
  stageId: CustomerFunnelStage;
  stage: string;
  outcome: string;
  job: string;
  demandPhase: string;
}[] = [{
  stageId: 'awareness',
  stage: 'Awareness',
  outcome: 'Get noticed',
  job: 'Help the right people see and remember you.',
  demandPhase: 'create'
}, {
  stageId: 'trial',
  stage: 'Trial',
  outcome: 'Let them experience it',
  job: 'Put the product in their hands and prove it delivers.',
  demandPhase: 'create'
}, {
  stageId: 'consideration',
  stage: 'Consideration',
  outcome: 'Give them a reason',
  job: 'Show why your product matters and why it is right for them.',
  demandPhase: 'strengthen'
}, {
  stageId: 'intent',
  stage: 'Intent',
  outcome: 'Build preference',
  job: 'Move people from interest to decision and preference for you.',
  demandPhase: 'strengthen'
}, {
  stageId: 'purchase',
  stage: 'Purchase',
  outcome: 'Make buying easy',
  job: 'Be easy to find, easy to choose and easy to buy.',
  demandPhase: 'convert'
}, {
  stageId: 'loyalty',
  stage: 'Loyalty',
  outcome: 'Keep them coming back',
  job: 'Deliver an experience worth buying again and recommending.',
  demandPhase: 'convert'
}];

/**
 * "Consumer journey" framework block: the funnel-stage header band and the
 * grid of clickable journey-stage cards that deep-link into the inspiration feed.
 */
export function DemandConsumerJourneyBlock() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-3 border-b-2 border-gray-950 bg-[#211d4f] px-5 py-5 text-white"><CircleDot className="h-5 w-5 shrink-0 text-[#ff7354]" aria-hidden="true" /><div><p className="text-2xl font-black tracking-[-0.03em] sm:text-3xl">Consumer journey</p><p className="mt-1 text-sm leading-6 text-white/60">Where are they now? What needs to happen next?</p></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid border-b border-gray-950 text-xs font-black uppercase tracking-[0.12em] lg:grid-cols-6"><div className="bg-[#ff5a36] px-4 py-2.5 text-white lg:col-span-2">Create awareness</div><div className="bg-[#e04820] px-4 py-2.5 text-white lg:col-span-2">Be demanded</div><div className="bg-[#159a84] px-4 py-2.5 text-white lg:col-span-2">Convert demand</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="overflow-hidden border-2 border-gray-950 bg-white">{t0}<div>{t1}<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6">{journeyOutcomes.map(_temp)}</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(item, index) {
  return <Link key={item.stage} href={buildInspirationFeedHref("stages", item.stageId)} className="group relative cursor-pointer border-l border-t border-gray-200 px-4 py-5 outline-none transition-colors first:border-l-0 hover:bg-[#fff5f0] focus-visible:bg-[#fff5f0] focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#ff5a36] lg:border-t-0"><div className="flex items-center justify-between gap-2"><span className={`${TEXT.stageLabel} text-[#d63f20]`}>{item.stage}</span><span className="text-xs font-black text-gray-300">0{index + 1}</span></div><p className={`${TEXT.stageOutcome} group-hover:text-[#d63f20]`}>{item.outcome}</p><p className={`${TEXT.stageDescription} text-gray-500`}>{item.job}</p>{index < journeyOutcomes.length - 1 && <ArrowRight className="absolute -right-3 top-5 z-10 hidden h-5 w-5 rounded-full bg-white text-gray-400 lg:block" aria-hidden="true" />}</Link>;
}